import type { NextPage } from 'next'
import { PrivacyPolicy } from '@/client/modules/PrivacyPolicy'
import { PrivacyPolicyProps } from '@/client/modules/PrivacyPolicy/types'
import { getCMSContent } from '@/client/utils'

const PrivacyPolicyPage: NextPage<PrivacyPolicyProps> = (data) => <PrivacyPolicy {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'PRIVACY_POLICY')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default PrivacyPolicyPage
